import * as actions from './types';

const initialState = {
  prototypeEntries: {
    data: [],
    isLoading: false,
    selectedDays: [],
    oid: null,
    error: null,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case 'GET_PROTOTYPE_TIME_ENTRIES':
      return {
        ...state,
        prototypeEntries: {
          ...state.prototypeEntries,
          oid: action.oid || state.prototypeEntries.oid,
          selectedDays:
            action.selectedDays || state.prototypeEntries.selectedDays,
          isLoading: true,
          error: null,
        },
      };

    case 'GET_PROTOTYPE_TIME_ENTRIES_SUCCESS':
      return {
        ...state,
        prototypeEntries: {
          ...state.prototypeEntries,
          data: action.payload || [],
          isLoading: false,
          error: null,
        },
      };

    case 'GET_PROTOTYPE_TIME_ENTRIES_ERROR':
      return {
        ...state,
        prototypeEntries: {
          ...state.prototypeEntries,
          data: [],
          isLoading: false,
          error: action.error || 'Error fetching prototype time entries',
        },
      };

    case actions.UPSERT_PROTOTYPE_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        prototypeEntries: {
          ...state.prototypeEntries,
          data: state.prototypeEntries.data.map((protoTypeEntry) => {
            if (protoTypeEntry.requestId !== action.payload.requestId) {
              // No match, return as is
              return protoTypeEntry;
            }

            return {
              ...protoTypeEntry,
              parts: protoTypeEntry.parts.map((part) => {
                if (part.partId !== action.payload.partId) {
                  return part;
                }

                return {
                  ...part,
                  processes: part.processes.map((process) => {
                    if (process.processId !== action.payload.processId) {
                      return process;
                    }

                    return {
                      ...process,
                      timeEntries: [...process.timeEntries.filter((entry) => {
                        return entry.id !== action.payload.id;
                      }),
                        action.payload,
                      ],
                    };
                  }),
                };
              }),
            };
          }),
          error: null,
        },
      };
    case actions.UPSERT_PROTOTYPE_TIME_ENTRY_ERROR:
    default:
      return state;
  }
};
